module.exports = __webpack_public_path__ + "static/media/useful-banner.796694e3.png";